import React from 'react';
import { ShoppingBag, ExternalLink } from 'lucide-react';
import { getCategoryInfo } from '../../utils/formatters';

export default function CompactGridView({ products = [] }) {
  if (!products || products.length === 0) {
    return (
      <div className="h-64 flex flex-col items-center justify-center p-8 text-center text-amber-200/60">
        <p className="text-sm font-medium">Không tìm thấy bao lì xì nào phù hợp.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-2 sm:gap-3 pb-12 select-none">
      {products.map((product) => {
        const targetUrl = product.affiliate_url || product.target_url || '#';
        const catInfo = getCategoryInfo(product.category_slug || product.category_name);

        return (
          <div
            key={product.id}
            onClick={() => {
              if (targetUrl && targetUrl !== '#') {
                window.open(targetUrl, '_blank', 'noopener,noreferrer');
              }
            }}
            className="bg-gradient-to-b from-[#7A1018] via-[#650B12] to-[#48060B] border border-[#9E1B28]/70 hover:border-[#F5A623] rounded-2xl p-2.5 flex flex-col justify-between group transition-all duration-200 cursor-pointer shadow-lixi-card hover:shadow-xl hover:-translate-y-1 relative"
            title={`${product.title} — Nhấp để nhận voucher`}
          >
            {/* Square thumbnail */}
            <div className="relative aspect-square rounded-xl overflow-hidden bg-[#2D060A] mb-2 border border-white/10">
              <img
                src={product.image_url}
                alt={product.title}
                referrerPolicy="no-referrer"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute top-1 right-1 pointer-events-none">
                {product.platform === 'shopee' ? (
                  <span className="p-1 rounded bg-[#EE4D2D]/95 text-white inline-flex shadow-xs">
                    <ShoppingBag size={9} />
                  </span>
                ) : (
                  <span className="p-1 rounded bg-black/90 text-white border border-white/20 inline-flex shadow-xs">
                    <svg className="w-2.5 h-2.5 fill-current" viewBox="0 0 24 24">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.29 0 .58.04.85.12V9.35a6.34 6.34 0 0 0-.85-.06A6.33 6.33 0 0 0 3 15.62a6.34 6.34 0 0 0 9.17 5.63 6.34 6.34 0 0 0 3.6-5.63V8.82a8.28 8.28 0 0 0 3.82.93V6.69z"/>
                    </svg>
                  </span>
                )}
              </div>
            </div>

            {/* Title & Action */}
            <div className="flex-1 flex flex-col justify-between">
              <div>
                <span className="text-[9px] font-bold text-[#F5A623] uppercase tracking-wider flex items-center gap-0.5 mb-1 truncate">
                  <span>{catInfo.icon}</span>
                  <span className="truncate">{catInfo.name}</span>
                </span>
                <h4 className="text-[11px] font-medium text-[#FFF5EB] line-clamp-2 leading-tight group-hover:text-amber-200 transition-colors mb-2">
                  {product.title}
                </h4>
              </div>

              <div className="pt-1.5 border-t border-[#8E1722]/50">
                <span className="w-full text-[10px] text-[#240306] bg-gradient-to-r from-[#F5A623] to-[#E58F10] py-1 rounded-lg font-bold flex items-center justify-center gap-1 shadow-xs group-hover:brightness-110">
                  <span>Nhận Voucher</span>
                  <ExternalLink size={9} />
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
